// extracted by mini-css-extract-plugin
module.exports = {"ratesPage":"styles-module--ratesPage--uwLPv","ratesTable":"styles-module--ratesTable--36pRI","rateRow":"styles-module--rateRow--3pMUT","block":"styles-module--block--2tbzI"};